export interface userBaseViewModel {
    createdByUserId: string;
    modifiedByUserId: string;
    createdByUserName: string;
    modifiedByUserName: string;
    dateCreated: string;
    dateModified: string;
}
export interface UserListViewModel extends userBaseViewModel {
    userId: string;
    userName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    isActive: boolean;
    roleId: string;
    roleDisplayName: string;
    roleKey: string;
    userRoleId: string;
    cityId: string;
    cityName: string;
    zipCode: string;
    address: string;
    phoneDialCode: string;
    countryId: string;
    stateId: string;
    countryName: string;
    stateName: string;
    countryISOCode: string;
    isDefaultCM: boolean;
    designationId: string;
    designationName: string;
    isSubContractor: boolean;
    roles: rolesUserViewModel[]
}
export interface rolesUserViewModel {
    roleKey: string;
    roleId: string;
    roleDisplayName: string;
}

export interface Users {
    firstName: string;
    isActive: string;
    lastName: string;
    phoneNumber: string;
    userId: string
    userName: string;
}
export interface countryShortViewModel {
    countryId: string,
    countryName: string,
    countryISOCode: string,
    isActive: boolean,
    isSelected: boolean,
    dialCode: string;
}



export interface roleShortViewModel {
    roleId: string,
    roleKey: string,
    roleDisplayName: string,
    isActive: boolean,
    isSelected: boolean
}
export interface Designation {
    designationId: string,
    designationKey: string,
    designationDisplayName: string,
    isActive: boolean
}
export interface UserViewModel {
    userId: string;
    userName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    isActive: boolean;
    roleId: string;
    roleDisplayName: string;
    userRoleId: string;
    cityId: string;
    cityName: string;
    zipCode: string;
    address: string;
    phoneDialCode: string;
    countryId: string;
    stateId: string;
    countryName: string;
    stateName: string;
    countryISOCode: any;
    isDefaultCM: boolean;
    designationId: string;
    designationName: string;
    isSubContractor: boolean;
    profilePicBase64: string;
    profilePicName: string;
    isAllowPermissionForWeeklyDocUpload: boolean;
    weeklyMeetDocDeptId: string;
    weeklyMeetDocDeptName: string;
    userRoles: userRoleDTO[];
    canSaveSubmitPastPayroll: boolean;
}
export interface userRoleDTO {
    userRoleId: string;
    roleId: string;
    roleKey: string;
    roleDisplayName: string;
    isDefaultRole: boolean;
    isActive: boolean;
}
export class loggedInUserViewModel {
    userId!: string;
    userName!: string;
    firstName!: string;
    lastName!: string;
    phoneNumber!: string;
    isActive!: boolean;
    roleId!: string;
    roleDisplayName!: string;
    roleKey!: string;
    userRoleId!: string;
    baseCityId!:string;
    cityId!: string;
    cityName!: string;
    zipCode!: string;
    address!: string;
    phoneDialCode!: string;
    countryId!: string;
    stateId!: string;
    countryName!: string;
    stateName!: string;
    countryISOCode!: string;
    isDefaultCM!: boolean;
    designationId!: string;
    designationName!: string;
    isSubContractor!: boolean;
    profilePicBase64!: string;
    profilePicName!: string;
    timezoneName!: string;
    userRoles!: userRoleDTO[];
    moduleAccess!: roleModuleAccess[];
    companyInfo!: companyInformation;
    todaysDate!: string;
}
export interface roleModuleAccess {
    moduleKey: string;
    groupKey: string;
}
export interface companyInformation {
    companyName: string;
    appVersion: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    phoneNumber: string;
    url: string;
    email: string;
}
export interface userRoleDTO {
    userRoleId: string;
    roleId: string;
    roleKey: string;
    roleDisplayName: string;
    isDefaultRole: boolean;
    isActive: boolean;
}

export class userListExportToExcel {
    public "First Name": string;
    public "Last Name": string;
    public "Email": string;
    public "State": string;
    public "City": string;
    public "Company Title": string;
    public "Company Role": string;

    constructor(userDto: UserListViewModel) {
        this["First Name"] = userDto.firstName;
        this["Last Name"] = userDto.lastName;
        this["Email"] = userDto.userName;
        this["State"] = userDto.stateName;
        this["City"] = userDto.cityName;
        this["Company Title"] = userDto.designationName;
        this["Company Role"] = userDto.roleDisplayName;
    }
}
export interface userShortViewModel {
    userId: string;
    userName: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
}
export interface accountExeManagerAndCoordinatorViewModel {
    userId: string;
    firstName: string;
    lastName: string;
    fullName: string;
    roleDisplayName: string;
    roleKey: string;
}
export interface forgotPasswordSendCodeDTO {
    userName: string;
}
export interface resetPasswordByCodeDTO {
    userName: string;
    authCode: string;
    password: string;
}

export interface cityManagerByCityViewModel {
    userId: string;
    firstName: string;
    lastName: string;
    fullName: string;
    cityId: string;
    roleDisplayName: string;
    roleKey: string;
    emailAddress: string;
}
export interface userRoleViewModel {
    userId: string;
    firstName: string;
    lastName: string;
    fullName: string;
    emailAddress: string;
    roleDisplayName: string;
    roleKey: string;
}